<div class="progress-status progress-status--{{ imageType }}">
  <div class="progress-status__icon">
    <img *ngIf="imageUrl" class="icon" [src]="imageUrl" />
  </div>
  <div class="progress-status__text-wrapper">
    <div class="progress-status__title">{{ title }}</div>
    <div class="progress-status__description">{{ description }}</div>
  </div>
</div>
